module.exports = __webpack_public_path__ + "static/img/tst2-03.e61e7df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-03.jpg
// module id = gWCJ
// module chunks = 1